
var regularVariants = {
    39403668078766: "Calming",
    39403688296622: "Pain Relief",
    39403685019822: "Skin & Coat",
    39474579898542: "Probiotic",
    39403667325102: "Hip & Joint",
    43119155380398: "Eye Support",
    43141744951470: "Multivitamin",
    44403171033262: "Anal Glands",
    43863228711086: "Allergy & Immune",
    44053690712238: "5-in-1 Dog Wash",
    44403491143854: "Probiotic (Turkey & Bacon)",
    44403510968494: "Skin & Coat (Turkey & Bacon)",
    45054690164910: "Dental Wash",
    45054822809774: "Urinary & Bladder",
  },
  getFlavoredVersion = {
    39474579898542: 44403491143854,
    39403685019822: 44403510968494,
    39475091898542: 44403500056750,
    39475091177646: 44403511328942,
  },
  discountedVariants = {
    39475059392686: "Calming",
    39475084689582: "Pain Relief",
    39475091177646: "Skin & Coat",
    39475091898542: "Probiotic",
    39475072827566: "Hip & Joint",
    43119330295982: "Eye Support",
    43141757599918: "Multivitamin",
    43533318815918: "Anal Glands",
    43868109635758: "Allergy & Immune",
    44053697724590: "5-in-1 Dog Wash",
    44403500056750: "Probiotic (Turkey & Bacon)",
    44403511328942: "Skin & Coat (Turkey & Bacon)",
    45054706516142: "Dental Wash",
    45054831591598: "Urinary & Bladder",
  },
  getUpsellBodyText = {
    39475091177646: "A powerful duo to protect from itching, allergies, paw biting and help renew your dog's coat. Try them for 50% off!",
    39475091898542: "Protect your dog inside and out by boosting their gut health and immunity from allergies. Try them for 50% off!",
    39475084689582: "The natural way to calming and relieving your pup of pain and stress, and they're delicious.",
    39475059392686: "These delicious chews help with separation anxiety, stress, travels and more! Try them for 50% off.",
    39475072827566: "Get to the root of the pain by supporting your dog's hip, joints and muscles with these delicious chews. Try them for 50% off!",
    43119330295982: "Get longer lasting results and keep your dog's vision in top shape with an extra jar at 50% off!",
    43141757599918: "Complete their diet with robust nutrition thanks to these 15-in 1 chews.",
    43533318815918: "Get rid of scooting, digestive issues and odors with these delicious chews at 50% off!",
    43868109635758: "We recommend another month's supply for more effective, longer lasting protection from allergies. Add another for 50% off!",
    44053697724590: "Running out of dog shampoo can be annoying. Click here to save $5 by adding an extra bottle!",
    44403500056750: "Protect your dog inside and out by boosting their gut health and immunity from allergies. Try them for 50% off!",
    44403511328942: "A powerful duo to protect from itching, allergies, paw biting and help renew your dog's coat. Try them for 50% off!",
    45054706516142: "Save and get longer lasting results with this special offer on an extra bottle of our Dental Wash.",
    45054831591598: "Save and get longer lasting results with this special offer on an extra jar of our UTI Chews.",
  },
  getUpsellImage = {
    39475059392686: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/calming.png",
    39475084689582: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/pairelief.png",
    39475091177646: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/skincoat.png",
    39475091898542: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/probiotic.png",
    39475072827566: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/hipjoint.png?v=12",
    43119330295982: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/eyesupport-cover.png?v=1658313904",
    43141757599918: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/multivitamin-cover.png?v=1658313905",
    43533318815918: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/analglands_x190.png?v=1667978221",
    43868109635758: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-allergy_x190.png?v=1680189123",
    44053697724590: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/shop-shampoo1_x200.png?v=1690351334",
    44403500056750: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/probiotic.png",
    44403511328942: "https://cdn.shopify.com/s/files/1/0506/0424/5166/t/1/assets/skincoat.png",
    45054706516142: "https://cdn.shopify.com/s/files/1/0506/0424/5166/files/dental-wash-cover-2.png?v=1715170609",
    45054831591598: "https://pawfy.com/cdn/shop/files/urinary-cover_e64e9f6c-fc32-4c34-a009-51cedcc89dd1_400x620.png?v=1713432130",
  },
  getUpsell = {
    39403668078766: 39475091898542, // Calming upsell is Probiotic
    39403688296622: 39475072827566, // Pain Relief upsell is Hip & Joint
    39403685019822: 39475091898542, // Skin & Coat upsell is Probiotic
    39474579898542: 39475091177646, // Probiotic upsell is Skin & Coat
    44403491143854: 44403511328942, // Probiotic (TB) upsell is Skin & Coat (TB)
    39403667325102: 39475084689582, // Hip & Joint upsell is Pain Relief
    43119155380398: 43141757599918, // Eye Support upsell is Multivitamin
    43141744951470: 39475091898542, // Multivitamin upsell is Probiotic
    44403171033262: 39475091898542, // AG is Probiotic
    43863228711086: 39475091177646, // Allergy is Skin & Coat
    44053690712238: 39475091177646, // Shampoo - Skin Coat
    44403510968494: 44403500056750, // Skin & Coat (TB) - Probiotic (TB)
    45054690164910: 44053697724590, // "Dental Wash",
    45054822809774: 39475091898542, // "Urinary & Bladder"
  },
  getDiscountedVariant = {
    39403668078766: 39475059392686,
    39403688296622: 39475084689582,
    39403685019822: 39475091177646,
    39474579898542: 39475091898542,
    39403667325102: 39475072827566,
    43119155380398: 43119330295982,
    43141744951470: 43141757599918,
    44403171033262: 43533318815918,
    43863228711086: 43868109635758,
    44053690712238: 44053697724590,
    44403491143854: 44403500056750,
    44403510968494: 44403511328942,
    45054690164910: 45054706516142,
    45054822809774: 45054831591598,
  },
  getSellingPlan = {
    //variant : sellingPlanID
    39474579898542: 499220654, // probiotic
    39403685019822: 497811630, // skin and coat
    39403668078766: 497778862, // calming
    39403667325102: 499187886, // hip and Joint
    39403688296622: 499155118, // pain relief
    39475091898542: 530743470, // probiotic
    43141744951470: 2076213422, // multivitamin
    43863228711086: 2422374574, // allergy
    44053690712238: 2582282414, // shampoo
    43119155380398: 2076278958, // eye support
    44403171033262: 2882535598, // anal glands
    43141757599918: 2076246190, // multivitamin special
    43119330295982: 2076311726, // eye support special
    43533318815918: 2164687022, // anal glands special
    43868109635758: 2422407342, // allergy special
    44053697724590: 2582249646, // shampoo special
    39475091177646: 530710702, // skin and coat special
    39475059392686: 530677934, // calming special
    39475072827566: 530645166, // hip and Joint special
    39475084689582: 530612398, // pain relief special
    44403510968494: 2881290414, // Skin & Coat (Turkey & Bacon)
    44403511328942: 2881257646, //Skin & Coat Special (Turkey & Bacon)
    44403491143854: 2881323182, //Probiotic (Turkey & Bacon)
    44403500056750: 2881355950, //Probiotic Special (Turkey & Bacon)
    45054690164910: 3268116654, // Dental Wash
    45054822809774: 3268182190, // Urinary
    45054706516142: 3268149422, // dental wash special
    45054831591598: 3268214958, // urinary special
  };

var Pawfy = {
  initUpsell: function (quantity, parentVariantID) {
    var upsellName = "",
      upsellVariantID = 0,
      upsellHeading = document.querySelector(".upsell b span"),
      upsellWrapper = document.querySelector(".upsell"),
      upsellBody = document.querySelector(".upsell p"),
      upsellImg = document.querySelector(".upsell img");
    if (document.body.classList.contains("product-page")) {
      parentVariantID = Number(document.querySelector("div#shopify-section-v5header ~ main").dataset.variant);
    }
    upsellWrapper.classList.remove("hip", "pain", "skin", "calming", "probiotic", "multivitamin", "eye", "5-in-1", "anal", "urinary", "mouth");

    if (parseInt(quantity) == 1) {
      upsellVariantID = getDiscountedVariant[parentVariantID];
      upsellName = String(regularVariants[parentVariantID]);
      upsellHeading.innerText = `Add Another ${parentVariantID == 44053690712238 || parentVariantID == 45054690164910 ? "Bottle" : "Jar"} For Just $19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    } else {
      upsellVariantID = getUpsell[parentVariantID];
      upsellName = String(discountedVariants[upsellVariantID]);
      upsellHeading.innerText = `Add Our ${upsellName} ${parentVariantID == 44053690712238 || parentVariantID == 45054690164910 ? "" : "Jar"} For Just $19.99!`;
      upsellBody.innerText = getUpsellBodyText[upsellVariantID];
      upsellImg.src = getUpsellImage[upsellVariantID];
    }

    upsellWrapper.classList.add(upsellName.split(" ")[0].toLocaleLowerCase());
    upsellWrapper.dataset.variant = upsellVariantID;

    document.getElementById("addToCart").addEventListener("click", function (ev) {
      ev.preventDefault();
      var primaryVariant = window.substituteVariant ? window.substituteVariant : document.querySelector("div#shopify-section-v5header ~ main").dataset.variant,
        selectedUpsellVariant = document.querySelector(".upsell").dataset.variant,
        primaryUpsellVariant = window.substituteVariant ? getFlavoredVersion[selectedUpsellVariant] : selectedUpsellVariant;
      var xhr = new XMLHttpRequest(),
        isSubscription = document.querySelector("[value='subsave']").checked;
      var items = isSubscription
        ? [
            {
              quantity: document.querySelector(".upsell__check").checked ? 1 : 0,
              id: primaryUpsellVariant,
              selling_plan: getSellingPlan[primaryUpsellVariant],
              properties: {
                Promo: "AutoShip Offer",
              },
            },
            {
              quantity: Number(document.querySelector(".come-first").innerText.trim().substr(0, 1).trim()),
              id: primaryVariant,
              selling_plan: getSellingPlan[Number(primaryVariant)],
              properties: {
                Promo: "AutoShip Offer",
              },
            },
          ]
        : [
            {
              quantity: document.querySelector(".upsell__check").checked ? 1 : 0,
              id: primaryUpsellVariant,
              properties: {
                Promo: "Product Upsell",
              },
            },
            {
              quantity: Number(document.querySelector(".come-first").innerText.trim().substr(0, 1).trim()),
              id: primaryVariant,
              properties: {
                Promo: "Product Upsell",
              },
            },
          ];
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          window.location.href = `/checkout?discount=${document.querySelector("main").dataset.variant == '39474579898542' ? "METAP50" : "METAJ50"}`;
        }
      };

      xhr.open("POST", "/cart/add.js", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(
        JSON.stringify({
          attributes: {
            Special: "Product Special",
          },
          items: items,
        })
      );
    });
  },
  randomInteger: function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  },
  initCarousels: function () {
    if (document.getElementById("homepage-product-slider")) {
      if (document.querySelectorAll("#homepage-product-slider .splide__slide").length > 3 || window.innerWidth <= 820)
        new Splide("#homepage-product-slider", {
          type: "loop",
          perPage: 3,
          gap: window.innerWidth <= 820 ? 16 : 48,
          autoplay: false,
          padding: 16,
          interval: 6000,
          pagination: false,
          arrows: true,
          arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
          breakpoints: {
            767: {
              perPage: 2,
            },
            1024: {
              perPage: 2,
            },
          },
        }).mount();
    }
    if (document.getElementById("product-slider")) {
      new Splide("#product-slider", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: false,
        interval: 6000,
        pagination: false,
        padding: window.innerWidth <= 820 ? 10 : 48,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        arrows: true,
      }).mount();
    }
    if (window.innerWidth <= 560 && document.getElementById("inside")) {
      new Splide("#inside", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 0 : 48,
        autoplay: false,
        interval: 6000,
        pagination: false,
        padding: window.innerWidth <= 820 ? 0 : 48,
        arrows: true,
        arrowPath: "M24.3023 1.44192L31.0003 8.13982M24.3023 14.8377L31.0003 8.13982M31.0003 8.13982L-4.27461e-05 8.14054",
        breakpoints: {
          560: {
            perPage: 1,
          },
          820: {
            perPage: 2,
          },
        },
      }).mount();
    }
    if (document.getElementById("two-packs")) {
      if (window.innerWidth <= 1023) {
        new Splide("#two-packs", {
          type: "loop",
          perPage: 1,
          gap: 32,
          autoplay: false,
          interval: 6000,
          autoHeight: true,
          pagination: false,
          padding: 32,
          arrows: true,
          breakpoints: {
            1023: {
              perPage: 2,
            },
            767: {
              perPage: 1,
            },
          },
          arrowPath:
            "M13.8457 17.718C13.4591 17.718 13.1457 18.0314 13.1457 18.418C13.1457 18.8046 13.4591 19.118 13.8457 19.118L13.8457 17.718ZM26.8016 18.9129C27.0749 18.6396 27.0749 18.1964 26.8016 17.923L22.3468 13.4682C22.0734 13.1949 21.6302 13.1949 21.3568 13.4682C21.0835 13.7416 21.0835 14.1848 21.3568 14.4582L25.3166 18.418L21.3568 22.3778C21.0835 22.6511 21.0835 23.0943 21.3568 23.3677C21.6302 23.6411 22.0734 23.6411 22.3468 23.3677L26.8016 18.9129ZM13.8457 19.118L26.3066 19.118L26.3066 17.718L13.8457 17.718L13.8457 19.118Z",
        }).mount();
      }
    }
    if (document.getElementById("testimonials-new")) {
      if (window.innerWidth >= 820) {
        document.querySelectorAll("#testimonials-new li.mobile-show").forEach((button) => {
          button.remove();
        });
      } else {
        document.querySelectorAll("#testimonials-new li:not(.mobile-show)").forEach((button) => {
          button.remove();
        });
      }
      var splide = new Splide("#testimonials-new", {
        type: "loop",
        perPage: 1,
        gap: window.innerWidth <= 820 ? 16 : 48,
        autoplay: true,
        interval: window.innerWidth <= 820 ? 6000 : 30000,
        autoHeight: true,
        focus: "center",
        pagination: false,
        padding: window.innerWidth <= 820 ? 48 : 24,
        arrows: true,
        arrowPath:
          "M13.8457 17.718C13.4591 17.718 13.1457 18.0314 13.1457 18.418C13.1457 18.8046 13.4591 19.118 13.8457 19.118L13.8457 17.718ZM26.8016 18.9129C27.0749 18.6396 27.0749 18.1964 26.8016 17.923L22.3468 13.4682C22.0734 13.1949 21.6302 13.1949 21.3568 13.4682C21.0835 13.7416 21.0835 14.1848 21.3568 14.4582L25.3166 18.418L21.3568 22.3778C21.0835 22.6511 21.0835 23.0943 21.3568 23.3677C21.6302 23.6411 22.0734 23.6411 22.3468 23.3677L26.8016 18.9129ZM13.8457 19.118L26.3066 19.118L26.3066 17.718L13.8457 17.718L13.8457 19.118Z",
      }).mount();
      setTimeout(function () {
        splide.go(">");
        setTimeout(function () {
          splide.go("<");
        }, 500);
      }, 400);
    }
  },
  customSticky: function () {
    if (window.scrollY >= 10) {
      document.querySelector("header.header").classList.add("header--sticky");
    } else {
      document.querySelector("header.header").classList.remove("header--sticky");
    }
  },
  initResponsiveMenu: function () {
    document.querySelector(".menu-toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector("header.header").classList.toggle("active");
      document.querySelector("header.header ul").classList.toggle("active");
    });
  },
  createElementFromHTML: function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },
  initFAQ: function () {
    var questions = document.querySelectorAll(".faq__list-question");
    for (var j = 0; j < questions.length; j++) {
      questions[j].addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        var that = this;
        if (that.classList.contains("active")) {
          that.nextElementSibling.classList.remove("active");
          that.classList.remove("active");
        } else {
          var answers = document.querySelectorAll(".faq__list-answer");

          for (var i = 0; i < answers.length; i++) {
            answers[i].classList.remove("active");
          }

          for (var j = 0; j < questions.length; j++) {
            questions[j].classList.remove("active");
          }

          that.classList.add("active");
          that.nextElementSibling.classList.add("active");
        }
      });
    }
  },
  insertAfter: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  },
  insertBefore: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode);
  },
  toggleTabs: function () {
    var tabs = document.querySelectorAll(".pawfy-tab__header-item"),
      contents = document.querySelectorAll(".pawfy-tab__content-item");
    for (var j = 0; j < tabs.length; j++) {
      tabs[j].addEventListener("click", function () {
        for (var c = 0; c < contents.length; c++) {
          contents[c].classList.remove("active");
          tabs[c].classList.remove("active");
        }
        this.classList.add("active");
        document.querySelector(".pawfy-tab__content-item[data-id='" + this.dataset.id + "']").classList.add("active");
      });
    }
  },

  rewordReCharge: function () {
    var root = document.querySelector("section.rc-login");
    var customer =
      Pawfy.getCookie("subscription_customer").length > 5 ? JSON.parse(Pawfy.getCookie("subscription_customer")) : JSON.parse(JSON.stringify({ isSub: false, email: "" }));
    var isSub = customer.isSub,
      customerEmail = customer.email;
    document.body.classList.add("recharge-login");
    var sectionTitle = document.querySelector("section.rc-login").querySelector("h1.rc-login--header-title");
    var sectionBody = document.querySelector("section.rc-login").querySelector("label.rc-login-form-label");
    if (sectionBody) {
      if (isSub && !!document.getElementById("rc-email")) {
        document.getElementById("rc-email").value = customerEmail;
        //document.getElementById("login_verification").submit();
        sectionTitle.innerText = "Access Subscription";
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";

        sectionBody.innerText = "We have detected a subscription account with this e-mail. Click 'Submit' to get access to your account.";
      } else {
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";
        sectionTitle.innerText = "Access Subscription";
        sectionBody.innerHTML = "Please enter <b>the email you used for your order</b> to access your subscription.";
        Pawfy.insertAfter(
          Pawfy.createElementFromHTML(`<div style="font-size: 12px;padding: 0 2rem;text-align: center;color: #123840;"><br><h4 style="
      font-size: 18px;
      margin: 0rem 0 16px 0;
  ">Need Help?</h4>You may access your subscription using this page to modify your delivery frequency or cancel your subscription. In order to gain access, please ensure you are using the same email you placed your initial order with.
      <br>

         <br>
      <b>If you need help managing your subscription, please <a href="/pages/contact">Contact Us Here</a>. We're happy to help you manage your subscription as needed.</b></div>`),
          document.querySelector(".rc-login--body")
        );
        root.style.opacity = 1;
      }
    } else {
      if (isSub) {
        sectionBody.innerHTML = `
    We have sent you an e-mail to: <b>${customerEmail}</b><br>
    Please check your inbox (including spam) for a link to access your subscription.
    `;
      }
      root.style.opacity = 1;
    }
  },

  setCookie: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  initNotification: function () {
    var notificationEl = document.getElementById("pawfy-notification");
    if (!notificationEl) {
      return false;
    }
    if (notificationEl.innerText.trim().length > 10) {
      let notification = Pawfy.getCookie("notification");
      if (notification !== "true") {
        notificationEl.style.display = "block";
        notificationEl.classList.remove("inactive");
      }
      document.getElementById("close-notification").addEventListener("click", function () {
        Pawfy.setCookie("notification", "true", 10);
        notificationEl.classList.add("inactive");
      });
    }
  },
  initReviews: function () {
    document.getElementById("submit").addEventListener("click", function (ev) {
      if (!document.getElementById("newReview").checkValidity()) return false;
      document.querySelector(".confirmation img").src = document.querySelector(".confirmation img").src;
      document.querySelector(".confirmation").classList.add("show");
      setTimeout(function () {
        document.querySelector(".reviews-modal").classList.remove("visible");
        document.querySelector(".confirmation").classList.remove("show");
      }, 2000);
    });
    var rateStars = document.getElementsByName("rating"),
      allReviews = document.querySelectorAll("[data-rating]"),
      readmores = document.querySelectorAll(".read-more");

    for (var s = 0; s < rateStars.length; s++) {
      if (!rateStars[s]) return false;
      rateStars[s].addEventListener("click", function (ev) {
        var rating = this.value;
        var filtered = document.querySelectorAll("[data-rating='" + rating + "']");
        for (var a = 0; a < allReviews.length; a++) {
          var item = allReviews[a];
          item.classList.add("hide-animate");
        }
        setTimeout(function () {
          for (var a = 0; a < allReviews.length; a++) {
            var item = allReviews[a];
            item.classList.remove("show");
            item.classList.remove("show-animate");
            item.classList.add("hide");
          }
          for (var f = 0; f < filtered.length; f++) {
            var item = filtered[f];
            item.classList.add("show");
            item.classList.remove("hide");
            item.classList.remove("hide-animate");
          }

          setTimeout(function () {
            for (var f = 0; f < filtered.length; f++) {
              var item = filtered[f];
              item.classList.add("show-animate");
            }
          }, 300);
        }, 300);

        if (filtered.length == 0) {
          document.querySelector(".reviews-list__footer").classList.add("hide");
        } else {
          document.querySelector(".reviews-list__footer").classList.remove("hide");
        }
      });
    }

    for (var r = 0; r < readmores.length; r++) {
      if (!readmores[r]) return false;
      readmores[r].addEventListener("click", function (ev) {
        ev.preventDefault();
        this.closest("p").classList.add("active");
        this.remove();
      });
    }
    var currentPage = 1;
    document.getElementById("appendMoreReviews").addEventListener("click", (ev) => {
      ev.preventDefault();
      currentPage = currentPage + 1;
      if (currentPage == 4) {
        document.getElementById("appendMoreReviews").remove();
      }
      document.getElementById("reviewsList").dataset.page = currentPage;
    });
    document.getElementById("leaveReview").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.add("visible");
    });
    document.getElementById("closeModal").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.remove("visible");
    });
  },
  randomizeReviews: function () {
    var strings = ["Today", "1 Day Ago", "2 Days Ago", "3 Days Ago", "4 Days Ago", "Last Week", "Last Month"];
    var waybacks = document.querySelectorAll(".testimonials__card-author small");
    for (var i = 0; i < waybacks.length; i++) {
      waybacks[i].innerText = strings[Pawfy.randomInteger(0, 6)];
    }
  },
  upsellToggles: function () {
    var upsellToggles = document.querySelectorAll(".upsellToSub__input");
    for (var j = 0; j < upsellToggles.length; j++) {
      upsellToggles[j].addEventListener("change", function () {
        var controls = this.closest("li").querySelectorAll("label.upsellToSub");

        [].forEach.call(controls, (el) => {
          el.classList.add("active");
        });
        var theVariant = this.value.split(":")[0],
          qty = this.dataset.qty;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var xhrSUB = new XMLHttpRequest();
            xhrSUB.onreadystatechange = function () {
              if (xhrSUB.readyState == 4 && xhrSUB.status == 200) {
                window.location.href = "/checkout";
              }
            };
            xhrSUB.open("POST", "/cart/add.js", true);
            xhrSUB.setRequestHeader("Content-Type", "application/json");
            xhrSUB.send(
              JSON.stringify({
                items: [
                  {
                    quantity: qty,
                    id: theVariant,
                    selling_plan: getSellingPlan[theVariant],
                  },
                ],
              })
            );
          }
        };
        xhr.open("POST", "/cart/change.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send("line=" + this.closest("li").dataset.cartItemIndex + "&quantity=0");
      });
    }
  },
  initSubFlow: function () {
    Pawfy.setCookie("subscription_customer", JSON.stringify({ isSub: true, email: "" }), 365);
    if (document.body.classList.contains("recharge-login")) {
      var customer = JSON.parse(Pawfy.getCookie("subscription_customer"));
      var isSub = customer.isSub,
        customerEmail = customer.email;
      if (isSub && !!document.getElementById("customer_email")) {
        document.getElementById("customer_email").value = customerEmail;
        document.getElementById("login_verification").submit();
      }
    }
  },
  initBundler: function (js) {
    if (document.querySelectorAll(".addMultiple").length > 0) {
      var bundlers = document.querySelectorAll(".addMultiple");

      for (var i = 0; i < bundlers.length; i++) {
        bundlers[i].addEventListener("click", function (ev) {
          ev.preventDefault();
          var items = this.dataset.variants.split(","),
            itemsArray = [];
          for (var j = 0; j < items.length; j++) {
            itemsArray.push({
              quantity: 1,
              id: parseInt(items[j]),
              properties: {
                Promo: "Multipack Bundles (" + items.length + ")",
              },
            });
          }
          var xhr = new XMLHttpRequest();
          xhr.onreadystatechange = function () {
            if (xhr.readyState == 4 && xhr.status == 200) {
              window.location.href = "/checkout";
            }
          };
          xhr.open("POST", "/cart/add.js", true);
          xhr.setRequestHeader("Content-Type", "application/json");
          xhr.send(
            JSON.stringify({
              attributes: {
                Promo4: itemsArray.length + " Pack Bundle",
              },
              items: itemsArray,
            })
          );
        });
      }
    }
  },
  disableEmptyAddToCart: function (js) {
    var addToCart = document.getElementById("addToCart");
    var choices = document.querySelectorAll('[name="qty"]');
    addToCart.classList.add("disabled");
    for (i = 0; i < choices.length; i++) {
      choices[i].addEventListener("click", function () {
        addToCart.classList.remove("disabled");
      });
    }
  },
  productQuantitySelectorsBind: function (js) {
    var dropElement = document.querySelector("ul.product-atf__qty"),
      types = document.querySelectorAll('[name="type"]'),
      quantities = document.querySelectorAll('[name="qty"]'),
      monthlySmall = document.querySelector("small.monthly"),
      flavors = document.querySelectorAll('[name="flavor"]');

    for (var j = 0; j < quantities.length; j++) {
      quantities[j].addEventListener("click", function (ev) {
        var lis = this.closest("ul").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("come-first");
        }

        this.closest("li").classList.add("come-first");
        dropElement.classList.toggle("dropped");
        
      });
    }

    for (var j = 0; j < types.length; j++) {
      types[j].addEventListener("change", function () {
        var theClass = document.querySelector('[name="type"]:checked').value;
        dropElement.classList.remove("subsave", "ss", "otp");
        dropElement.classList.add(theClass);
        if (theClass == "ss") {
          monthlySmall.classList.add("active");
        } else {
          monthlySmall.classList.remove("active");
        }
      });
    }

    for (var f = 0; f < flavors.length; f++) {
      flavors[f].addEventListener("change", function () {
        document.querySelectorAll(".product-atf__flavor-list label").forEach((label) => {
          label.classList.remove("active");
        });
        var flavor = document.querySelector('[name="flavor"]:checked').value,
          variant = document.querySelector("div#shopify-section-v5header ~ main").dataset.variant;
        window.substituteVariant = flavor == "chicken" ? variant : getFlavoredVersion[variant];
        document.querySelector('[name="flavor"]:checked').closest("label").classList.add("active");
      });
    }
  },
  cartManipulations: function (js) {
    var cartRows = document.querySelectorAll('[action="/cart"] li.cart-items__item:not(.cart-items__item--upsell)');

    for (var j = 0; j < cartRows.length; j++) {
      var that = cartRows[j];
      var variant = that.dataset.cartItemKey.split(":")[0];
      var qty = that.dataset.cartItemQuantity;

      // if (that.querySelector(".product-details [data-cart-item-property-value]").innerText.toLowerCase().indexOf("autoship") > -1) {
      //   that.querySelector(".order-discount").classList.remove("hide");
      //   var ul = that.querySelector(".order-discount");
      //   ul.innerHTML = "";
      //   var li = document.createElement("li");
      //   li.classList.add("order-discount__item", "pawfy", "subscription");
      //   li.innerHTML =
      //     '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-saletag"><path d="M10 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm0-3H7a1 1 0 0 0-.71.29l-6 6a1 1 0 0 0 0 1.42l4 4a1 1 0 0 0 1.42 0c.19-.2 5.8-5.81 6-6A1 1 0 0 0 12 5V2a2 2 0 0 0-2-2z" fill="#231F20"></path></svg><span data-cart-item-discount-title="">subscription</span>';
      //   ul.appendChild(li);
      // }
      if (Object.getOwnPropertyNames(discountedVariants).includes(String(variant))) {
        that.classList.add("target-offer-killed");
        that.dataset.variant = variant;
      } else {
        that.classList.add("target-offer-killer");
        that.dataset.variant = variant;
        that.dataset.killVariant = getUpsell[variant];
        if (qty > 1) {
          that.querySelector("a.remove-line").dataset.variant = variant;
          that.querySelector("a.remove-line").dataset.killVariant = getUpsell[variant];
        } else {
          that.querySelector("a.remove-line").dataset.variant = variant;
          that.querySelector("a.remove-line").dataset.killVariant = getDiscountedVariant[variant];
        }
      }
      that.querySelector("a.remove-line").addEventListener("click", function (ev) {
        ev.preventDefault();
        var thus = this;
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            location.reload();
            Pawfy.cartManipulations();
          }
        };
        xhr.open("POST", "/cart/update.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

        if (typeof thus.dataset.killVariant !== "undefined") {
          xhr.send("updates[" + thus.dataset.variant + "]=0&updates[" + thus.dataset.killVariant + "]=0");
        } else {
          xhr.send("updates[" + thus.dataset.variant + "]=0");
        }
      });
    }
    var increments = document.querySelectorAll(".cart-items__item:not(.offer) .increment"),
      decrements = document.getElementsByClassName("decrement");
    for (var i = 0; i < increments.length; i++) {
      increments[i].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepUp();
      });
    }

    for (var d = 0; d < decrements.length; d++) {
      decrements[d].addEventListener("click", function () {
        this.closest("div").querySelector(".cart__qty-input").stepDown();
      });
    }

    if (document.querySelector('[name="checkout"]')) {
      var selector = document.querySelector('[data-cart-wrapper] > [name="checkout"]');
      if (selector) {
        selector.remove();
      }

      if (document.querySelector(".cart-header ~ input")) {
        document.querySelector(".cart-header ~ input").remove();
      }
    }
    var rogueRows = document.querySelectorAll("li.cart-items__item.offer"),
      regularRows = document.querySelectorAll("li.cart-items__item:not(.offer):not(.cart-items__item--upsell)");

    if (rogueRows.length > 0 && regularRows.length == 0) {
      var updateString = "updates[" + rogueRows[0].dataset.cartItemKey.split(":")[0] + "]=0";
      for (var i = 1; i < rogueRows.length; i++) {
        updateString = updateString + "&updates[" + rogueRows[i].dataset.cartItemKey.split(":")[0] + "]=0";
        rogueRows[i].remove();
      }

      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          location.reload();
        }
      };
      xhr.open("POST", "/cart/update.js", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.send(updateString);

      return false;
    }
  },
  cartUpsell: function (js) {
    var pricing = document.querySelector(".final-price");
    var value = Number(pricing.innerText.replace(/[^0-9\.-]+/g, ""));

    document.querySelectorAll(".upsell__check").forEach((upsell) => {
      upsell.addEventListener("click", function () {
        this.classList.toggle("active");
        pricing.innerText = "$" + (this.classList.contains("active") ? value + 19.99 : value).toFixed(2) + " USD";
      });
    });
    var xmlhttp = new XMLHttpRequest(),
      smallest = 100,
      upsellItem = {};
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == XMLHttpRequest.DONE) {
        if (xmlhttp.status == 200) {
          var itemsArray = JSON.parse(xmlhttp.responseText).items;
          for (var productItem in itemsArray) {
            var quantity = itemsArray[productItem].quantity;
            if (quantity < smallest && Object.getOwnPropertyNames(regularVariants).includes(String(itemsArray[productItem].id))) {
              smallest = quantity;
              upsellItem = itemsArray[productItem];
            }
          }

          if (!document.querySelector('[action="/cart"] li.cart-items__item')) {
            return false;
          }
          var currentName = String(discountedVariants[getDiscountedVariant[upsellItem.id]]);
          var upsells = document.querySelectorAll(".discounted-product");
          var upsellParent = false;

          for (i = 0; i < upsells.length; i++) {
            upsellParent = document.querySelector("[data-kill-variant='" + upsells[i].dataset.variant + "']");
          }

          document.querySelectorAll(".cart-items__item--upsell .cart-items__item-image").forEach((image) => {
            image.querySelector("img").src = getUpsellImage[getDiscountedVariant[upsellItem.id]];
            image.classList.add(currentName.split(" ")[0].toLowerCase());
            setTimeout(function () {
              image.closest(".cart-items__item--upsell").classList.add("show");
            }, 500);
          });

          var checkouts = document.querySelectorAll("button.cart__submit.btn.btn--small-wide");

          for (i = 0; i < checkouts.length; i++) {
            checkouts[i].addEventListener("click", function (ev) {
              ev.preventDefault();
              ev.stopPropagation();
              this.classList.add("active");
              if (document.querySelectorAll(".upsell__check.active").length > 0) {
                var xhr = new XMLHttpRequest();
                var xhrSUB = new XMLHttpRequest();
                xhr.onreadystatechange = function () {
                  if (xhr.readyState == 4 && xhr.status == 200) {
                    window.location.href = "/checkout";
                  }
                };
                xhr.open("POST", "/cart/add.js", true);
                xhr.setRequestHeader("Content-Type", "application/json");
                xhr.send(
                  JSON.stringify({
                    items: [
                      {
                        quantity: 1,
                        id: getDiscountedVariant[upsellItem.id],
                        properties: {
                          Promo: "Cart Special",
                        },
                      },
                    ],
                  })
                );
              } else {
                window.location.href = "/checkout";
              }
            });
          }
        } else if (xmlhttp.status == 400) {
          alert("There was an error 400");
        } else {
          alert("something else other than 200 was returned");
        }
      }
    };

    xmlhttp.open("GET", "/cart.js", true);
    xmlhttp.send();
  },
  klaviyoChecker: function (js) {
    var klaviyoAppeared = false;
    var klaviyoChecker = setInterval(function () {
      if (!klaviyoAppeared) {
        klaviyoAppeared = document.querySelector(".klaviyo-pawfy form");
      } else {
        var klaviyos = document.querySelectorAll("[class*='kl-private-reset-css']");
        for (var j = 0; j < klaviyos.length; j++) {
          klaviyos[j].removeAttribute("class");
        }
        document.querySelectorAll(".klaviyo-pawfy form > div > [data-testid]:last-child").forEach((testid) => {
          testid.classList.add("input-block", "input-block--flat-on-mobile");
        });

        document.querySelectorAll(".klaviyo-pawfy").forEach((testid) => {
          testid.classList.add("active");
        });
        clearInterval(klaviyoChecker);
      }
    }, 500);
  },
  getTransactionID: function () {
    const url = new URL(document.location.href);
    const searchParams = url.searchParams;

    var transactionID = searchParams.get("transaction_id");
    if (transactionID) {
      localStorage.setItem("transactionID", transactionID);
    }
  },
  pushTransactionID: function () {
    var transactionID = localStorage.getItem("transactionID");
    if (transactionID) {
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          console.log("successfully transferred transaction ID", transactionID);
        }
      };
      xhr.open("POST", "https://pawfy.go2cloud.org/", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
      xhr.send("aff_lsr?offer_id=1&transaction_id=" + transactionID);
    }
  },
  paintNotches: function () {
    var themeColor = "#ffffff";
    if (document.body.classList.contains("new-home")) {
      themeColor = "#d0c0ec";
    }
    if (document.body.classList.contains("product-page")) {
      themeColor = getComputedStyle(document.querySelector(".product-atf__slider")).getPropertyValue("background-color");
    }
    document.getElementById("themeColor").content = themeColor;
  },
  initFloaterATC: function () {
    var el = document.querySelector(".floater-atc"),
      atcElement = document.getElementById("addToCart"),
      atcPosition = window.scrollY + atcElement.getBoundingClientRect().top;
    el.addEventListener("click", function (ev) {
      ev.preventDefault();
      if (atcElement.getAttribute("disabled") == null) {
        atcElement.click();
      } else {
        document.querySelector(".buy-ribbon__wrapper a").click();
      }
    });
    window.addEventListener("scroll", function (e) {
      if (window.scrollY > atcPosition) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  },
  relatedProducts: function () {
    var relatedProducts = {
      39474579898542: ["allergy", "skincoat", "multivitamin"], //probiotic
      39403685019822: ["shampoo", "multivitamin", "probiotic"], //skincoat
      39403667325102: ["painrelief", "calming", "skincoat"], //hipjoint
      39403668078766: ["painrelief", "shampoo", "multivitamin"], //calming
      39403688296622: ["hipjoint", "calming", "multivitamin"], //painrelief
      43119155380398: ["multivitamin", "probiotic", "allergy"], //eyesupport
      43141744951470: ["probiotic", "skincoat", "shampoo"], //multivitamin
      44053690712238: ["skincoat", "calming", "multivitamin"], //shampoo
      43863228711086: ["probiotic", "skincoat", "shampoo"], // allergy
      44403171033262: ["probiotic", "multivitamin", "allergy"],
      45054690164910: ["probiotic", "multivitamin", "allergy"], //"Dental Wash",
      45054822809774: ["probiotic", "multivitamin", "allergy"], //"Urinary & Bladder"
    };
    var relatedProducts = relatedProducts[meta.product.variants[0].id];
    if (!relatedProducts) return false;
    var selector = "";
    relatedProducts.forEach((product) => {
      selector = selector + `:not(.product-${product})`;
    });
    document.querySelectorAll("#homepage-product-slider .splide__slide" + selector).forEach((element) => {
      element.remove();
    });
  },
  calculateVH: function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  },
};
var timeout = false;
window.addEventListener("resize", function () {
  // clear the timeout
  clearTimeout(timeout);
  // start timing for event "completion"
  timeout = setTimeout(Pawfy.calculateVH, 300);
});

Pawfy.calculateVH();
window.addEventListener("orientationchange", Pawfy.calculateVH);

Pawfy.customSticky();
Pawfy.initResponsiveMenu();
setTimeout(function () {
  Pawfy.initNotification();
}, 1000);
Pawfy.getTransactionID();

if (document.body.classList.contains("product-page")) {
  Pawfy.productQuantitySelectorsBind();
 // Pawfy.disableEmptyAddToCart();
  Pawfy.initFloaterATC();
  Pawfy.initUpsell(1);
}

if (document.body.classList.contains("product-page")) {
  Pawfy.relatedProducts();
}

if (document.body.classList.contains("reviews")) {
  //Pawfy.initReviews();
  //Pawfy.randomizeReviews();
}
if (
  document.body.classList.contains("contact-us") ||
  document.body.classList.contains("template-customers-login") ||
  document.body.classList.contains("template-customers-register")
) {
  Pawfy.toggleTabs();
}
if (document.body.classList.contains("template-cart")) {
  Pawfy.cartManipulations();
  Pawfy.cartUpsell();
  Pawfy.upsellToggles();
  if (!document.body.classList.contains("tester")) {
    Pawfy.initCarousels();
  }
}
if (!document.body.classList.contains("template-cart")) {
  Pawfy.initFAQ();
  Pawfy.initBundler();
  if (!document.body.classList.contains("tester")) {
    Pawfy.initCarousels();
  }
  Pawfy.klaviyoChecker();
}

window.addEventListener("scroll", Pawfy.customSticky);

if (document.body.classList.contains("template-")) {
  Pawfy.rewordReCharge();
}

Pawfy.paintNotches();
